import React, { useRef, useState } from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import emailjs from "emailjs-com";
import { storage } from "../../appwrite/appwrite";
import { ID } from "appwrite";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { Bounce, toast } from "react-toastify";

function LogoForm() {
  const recaptcha = useRef();
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const [url, setUrl] = useState(null);
  const [url2, setUrl2] = useState(null);
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    const formElements = form.current.elements;
    let isValid = true;
    // Loop through form elements to check for empty fields
    for (let i = 0; i < formElements.length; i++) {
      const element = formElements[i];
      if (element.hasAttribute("required") && !element.value) {
        isValid = false;
        element.focus(); // Focus on the first empty required field
        break; // Exit the loop after finding the first empty field
      }
    }
    if (isValid) {
      const captchaValue = recaptcha.current.getValue();
      const formData = new FormData(form.current);
      if (captchaValue) {
        emailjs
          .sendForm(
            "service_2z2n80a",
            "template_6z1ryj6",
            form.current,
            "F60d83opzJ20A6FoL"
          )
          .then(
            (result) => {
              console.log("Email sent successfully:", result.text);
              toast('Your form has been submitted successfully.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
                });
              setTimeout(() => {
                navigate("/")
              }, 2000);
            },
            (error) => {
              console.log("Error sending email:", error.text);
              alert("Failed to send email. Please try again.");
            }
          );
      } else {
        alert("Please fill Captcha");
      }
    }
  };
  const handleFile = async (e) => {
    e.preventDefault();
    const filesArray = [...e.target.files];
    const urlstr = [];
    setLoading(true);
    for (const file of filesArray) {
      try {
        const promise = storage.createFile(
          "6785b4c2001dc86bea1b",
          ID.unique(),
          file
        );
        const id = await promise;
        if (id) {
          const fileView = await storage.getFileView(
            "6785b4c2001dc86bea1b",
            id.$id
          );
          if (fileView) urlstr.push(fileView);
        }
      } catch (error) {
        console.log(error);
      }
    }
    const strking = urlstr.join(" || ");
    setUrl(strking);
    setLoading(false);
  };

  const handleFile2 = async (e) => {
    e.preventDefault();
    const filesArray = [...e.target.files];
    const urlstr = [];
    setLoading2(true);
    for (const file of filesArray) {
      try {
        const promise = storage.createFile(
          "6785b4c2001dc86bea1b",
          ID.unique(),
          file
        );
        const id = await promise;
        if (id) {
          const fileView = await storage.getFileView(
            "6785b4c2001dc86bea1b",
            id.$id
          );
          if (fileView) urlstr.push(fileView);
        }
      } catch (error) {
        console.log(error);
      }
    }
    const strking = urlstr.join(" || ");
    setUrl2(strking);
    setLoading2(false);
  };
  return (
    <>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title={"Logo Form"}
          subtitle={"Logo Form"}
          className={"breadcrumb-area-two pt-175 pb-60"}
          showShape={false}
        />
        <div className="container consultation-form-wrap">
          <h2>Business Information</h2>
          <form className="form-card" onSubmit={handleSubmit} ref={form}>
            <div className="row">
              <div className="form-group col-sm-6 form-grp">
                <input
                  type="text"
                  name="full_name"
                  className="form-control"
                  placeholder="Full Name"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                  required
                />
              </div>
            </div>
            <div className="row my-4">
              <div className="form-group col-sm-6 form-grp">
                <label>Logo Name* which you want to use in Logo</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Logo Name"
                  name="logo_name"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Company Slogan which you want to use in Logo</label>
                <input
                  type="text"
                  className="form-control"
                  name="company_slogan"
                  placeholder="Company Slogan"
                />
              </div>
            </div>
            <div className="row my-4">
              <div className="form-group col-sm-6">
                <label>
                  Competitors Reference Optional, you can enter multiple Links
                </label>
                <textarea
                  className="form-control form-grp-text-area"
                  name="competitiors_reference"
                  placeholder="Competitors Reference"
                  required
                  rows="3"
                ></textarea>
              </div>
              <div className="form-group col-sm-6">
                <label>
                  Describe your business/logo* what is your Business/logo all
                  about
                </label>
                <textarea
                  className="form-control form-grp-text-area"
                  placeholder="Describe Your Business"
                  name="logo_desc"
                  rows="3"
                  required
                ></textarea>
              </div>
            </div>
            <div className="row my-4">
              <div className="form-group col-sm-6">
                <label>Why are you looking to change the logo?</label>
                <textarea
                  className="form-control form-grp-text-area"
                  name="change_logo"
                  placeholder="Reason for Logo Change"
                  required
                  rows="3"
                ></textarea>
              </div>
              <div className="form-group col-sm-6">
                <label>What do you want the new logo to accomplish?</label>
                <textarea
                  className="form-control form-grp-text-area"
                  placeholder="New Logo Goals"
                  name="logo_goals"
                  rows="3"
                  required
                ></textarea>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-6">
                <label>What you want in your logo Any additional details</label>
                <textarea
                  className="form-control form-grp-text-area"
                  placeholder="What you want in your logo"
                  required
                  rows="3"
                ></textarea>
              </div>
              <div className="form-group col-sm-6">
                <label>2,3 example of logo (from google and else)</label>
                <textarea
                  className="form-control form-grp-text-area"
                  placeholder="Examples of Logos (2-3)"
                  required
                  rows="3"
                ></textarea>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="my-3">Select Colors</h2>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                  onChange={(e) => setIsActive(!isActive)}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
                >
                  Select HEX Code
                </label>
              </div>
            </div>
            <div className={`row`}>
              <div className="form-group col-sm-6 form-grp">
                <label>
                  Primary Color Write the name or code, Like Blue, #FFFF00
                </label>
                <input
                  type={isActive ? "color" : "text"}
                  className="form-control"
                  defaultValue={"#FFAA17"}
                  placeholder="Enter color"
                  name="primary_color"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>
                  Secondary Color Write the name or code, Like Blue, #ffff
                </label>
                <input
                  type={isActive ? "color" : "text"}
                  name="secondary_color"
                  className="form-control"
                  defaultValue={"#212137"}
                  placeholder="Enter color"
                />
              </div>
            </div>
            <h2 className="mt-70">Business Card Details</h2>
            <div className="row my-4">
              <div className="form-group col-sm-6 form-grp">
                <label>Person name</label>
                <input
                  type="text"
                  name="person_name"
                  className="form-control"
                  placeholder="Person's Name"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Person's Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Person's Email"
                  name="person_email"
                  required
                />
              </div>
            </div>
            <div className="row my-4">
              <div className="form-group col-sm-6 form-grp">
                <label>Person Designation</label>
                <input
                  type="text"
                  name="person_designation"
                  className="form-control"
                  placeholder="Designation"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Person Phone Number#</label>
                <input
                  type="number"
                  name="personal_number"
                  className="form-control"
                  placeholder="Person Phone Number"
                  required
                />
              </div>
            </div>
            <div className="row my-4">
              <div className="form-group col-sm-6 form-grp">
                <label>Company Address</label>
                <input
                  type="text"
                  name="company_address"
                  className="form-control"
                  placeholder="Company Address"
                  required
                />
              </div>
              <div className="form-group col-sm-6 form-grp">
                <label>Company Phone#</label>
                <input
                  type="number"
                  name="company_phone"
                  className="form-control"
                  placeholder="Company Phone"
                  required
                />
              </div>
            </div>
            <div className="row ">
              <div className="col-sm-6 form-grp">
                <label>Attach a file (optional)</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={handleFile}
                  multiple
                  disabled={loading ? true : false}
                />
                {loading && (
                  <div id="fileLoader">
                    <div id="loader" className="loader">
                      <div className="loader-container" style={{ top: "5rem", left: "27%" }}>
                        <div className="loader-icon">
                          <span>Uploading Files</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-sm-6 form-grp">
                <label>What is the current logo?</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={handleFile2}
                  multiple
                  disabled={loading ? true : false}
                />
                {loading2 && (
                  <div id="fileLoader">
                    <div id="loader" className="loader">
                      <div
                        className="loader-container"
                        style={{ top: "5rem", left: "27%" }}
                      >
                        <div className="loader-icon">
                          <span>Uploading Files</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <input className="" value={url} name="attach_file" hidden/>
            <input className="" value={url2} name="current_logo" hidden/>
            <div className="row justify-content-center my-4">
              <ReCAPTCHA
                sitekey={"6LfrdtUqAAAAAFb4hjwtai1FHpMgpU76t_oQNuuK"}
                ref={recaptcha}
              />
              <div className="col-sm-2">
                <button
                  type="submit"
                  className="btn"
                  disabled={loading || loading2 ? true : false}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </Layout>
    </>
  );
}
export default LogoForm;
